export default __webpack_public_path__ + "static/media/Slider-03.cc039f8f.jpg";